import React from 'react'
import { useSelector } from 'react-redux'

import { renderDate } from '../../../common/dateUtils'
import GetAge from '../../components/GetAge'
import { Box, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  fieldLabel: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '15px',
    lineHeight: '18px',
    letterSpacing: '0.25px',
    color: '#142A39',
    textTransform: 'uppercase',
  },
  fieldValue: {
    fontStyle: 'normal',
    fontSize: '15px',
    lineHeight: '18px',
    letterSpacing: '0.25px',
    color: '#142A39',
    fontWeight: 700,
    backgroundColor: '#fff',
    padding: '7px 8px',
    borderRadius: '3px',
    marginLeft: '.5rem',
    marginRight: '1.5rem',
    textTransform: 'uppercase',
  },
}))

/**
 * Patient Info Header
 * To render patient details
 * @param {*} props
 * @returns
 */

const PatientInfoHeader = props => {
  const { patient = null, me, className, ...restProps } = props
  const styles = useStyles()

  const { customParticipantID, dob, sex, weight: weightIds } = patient || {}
  const patientWeight = useSelector(state => {
    const { isFetching, data } = state.app.dataSources.weights || {}
    if (!isFetching && data) {
      const weightsById = data.byId
      if (weightsById) {
        const weightInfo = weightsById[weightIds && weightIds[0]]
        if (weightInfo) return weightInfo.weight
      }
    }
    return null
  })

  const patientInfo = [
    {
      label: 'MRN',
      value: customParticipantID,
    },
    {
      label: 'DOB',
      value: dob ? renderDate(dob, me) : null,
    },
    {
      label: 'AGE',
      value: dob ? <GetAge dob={dob} onlyAge /> : null,
    },
    {
      label: 'SEX',
      value: sex ? sex.replace('_', ' ') : null,
    },
    {
      label: 'WEIGHT',
      value: Math.round(patientWeight),
    },
  ]
  const patientInfoField = (label, value) => (
    <Box key={label} className={styles.root}>
      <Typography variant="body2" className={styles.fieldLabel}>
        {label}
      </Typography>
      <Typography variant="body2" className={styles.fieldValue}>
        {value}
      </Typography>
    </Box>
  )
  return (
    <Box className={styles.root} {...restProps}>
      {patientInfo
        .filter(({ value }) => !!value)
        .map(({ label, value }) => patientInfoField(label, value))}
    </Box>
  )
}

export default PatientInfoHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/PatientInfoHeader/PatientInfoHeader.jsx